import {MaintenanceModeConfig} from '../../model/maintenance-config/maintenance-mode-config';
import {Injectable} from '@angular/core';

@Injectable()
export class MaintenancePropertyMapper {

  constructor() {
  }

  public mapProperty(property): MaintenanceModeConfig {
    const maintenanceModeConfig = new MaintenanceModeConfig();
    maintenanceModeConfig.enabled = property.enabled;
    maintenanceModeConfig.startDate = this.parse(property.startDate);
    maintenanceModeConfig.endDate = this.parse(property.endDate);
    return maintenanceModeConfig;
  }


  private parse(dateString): Date {
    if (dateString) {
      dateString = dateString.replace(/\D/g, ' ');
      const dateParts = dateString.split(' ');
      return new Date(dateParts[0], dateParts[1] - 1, dateParts[2], dateParts[3], dateParts[4], dateParts[5]);
    }
    return null;
  }
}
